import { gracefulFetch } from './gracefulFetch';

interface Props {
  state: any;
  values: any;
  sessionID: string;
  nonce: number;
}

export const postHelpForm = async ({ values, sessionID, nonce }: Props) => {
  let response: Response | null = null;

  try {
    response = await gracefulFetch({
      fetch: async () =>
        fetch('/api/help-form', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            fullname: encodeURIComponent(values.name || ''),
            email: encodeURIComponent(values.email || ''),
            case_id: encodeURIComponent(values.caseid || values.uuid || ''),
            message: encodeURIComponent(values.problem || ''),
            company: encodeURIComponent(values.company || ''),
            sessionID: encodeURIComponent(sessionID),
            nonce: encodeURIComponent(nonce.toString()),
            address: '' // honeypot field
          })
        })
    });
  } catch (e) {
    console.warn(e);
  }

  return response;
};
